/** @format */

import { combineReducers } from "redux";
import * as general from "./general";
import * as waba from "./waba";

const appReducer = combineReducers({
  auth: general.generalAuthReducer,
  waba: waba.generalWABAReducer,
});

export default appReducer;
